/**
 * SuccessStep - Winback accepted confirmation
 *
 * Shows success message after user accepts the discount.
 */

interface SuccessStepProps {
  onDismiss: () => void;
}

export function SuccessStep({ onDismiss }: SuccessStepProps) {
  return (
    <div className="flex flex-col items-center gap-6 py-4 text-center">
      {/* Success icon */}
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-catch-avocado-400">
        <svg
          className="h-8 w-8 text-catch-dark-blue-90"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-catch-dark-blue-90">You&apos;re all set!</h2>
        <p className="mt-2 text-catch-slate">
          Your discount has been applied. Thanks for staying with us.
        </p>
      </div>

      {/* Continue CTA */}
      <button
        onClick={onDismiss}
        className="flex w-full items-center justify-center rounded-full bg-catch-avocado-400 px-5 py-4 text-sm font-bold text-catch-dark-blue-90 transition-opacity hover:opacity-90"
      >
        Continue to Catch
      </button>
    </div>
  );
}

export default SuccessStep;
